import { Component, Input, OnInit } from '@angular/core';
import { CardItemComponent } from '../card-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';

@Component({
  selector: 'app-card-item-text',
  templateUrl: './card-item-text.component.html',
  styleUrls: [
    './card-item-text.component.scss',
    './../card-item.component.scss',
  ],
  standalone: false,
})
export class CardItemTextComponent extends CardItemComponent {
  constructor() {
    super();
  }
}
